document.addEventListener('DOMContentLoaded', function () {
  let hasRefreshed = false;

  const refreshDrawer = () => {
    setTimeout(() => {
      const formElement = document.querySelector('form[action^="/cart/add"]');
      const productJSON = document.querySelector('[data-product-json]');

      if (formElement && productJSON && window.cart?.getCart) {
        console.log('🟢 FoxKit bundle detected — refreshing cart drawer');
        window.cart.getCart();
      } else {
        console.warn("🟡 Cart or product form missing. Skipping refresh to avoid errors.");
      }
    }, 800); // Delay for variant sync
  };

  const observer = new MutationObserver((mutations, obs) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (
          node.nodeType === 1 &&
          (node.className?.includes('foxkit') ||
           node.id?.includes('foxkit') ||
           node.innerHTML?.includes('foxkit'))
        ) {
          if (!hasRefreshed) {
            hasRefreshed = true;
            refreshDrawer();
            obs.disconnect();
            return;
          }
        }
      }
    }
  });

  document.body.addEventListener('click', () => {
    if (!hasRefreshed) {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }, { once: true });
});